import { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { reduxForm, Field, Form } from 'redux-form';

import { TextField } from 'common/components/forms';
import { FormErrorNoRouter } from 'common/components/layout';
import { login } from 'redux/customer/actions';

import FacebookWidget from './FacebookLogin';
import GoogleWidget from './GoogleLogin';
import { validateLogin } from './validators';

class LoginWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMessage: null
    };
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const errorFunction = () => {
      this.setState({ showMessage: 'Error' });
    };
    const successFunction = () => {
      const { redirectLink } = this.props;
      if (redirectLink) {
        props.history.push(redirectLink);
      } else {
        props.history.push('/profile');
      }
    };
    props.login(data.email, data.password, successFunction, errorFunction);
    props.reset();
  };

  handleChange = () => {
    this.setState({ showMessage: null });
  };

  handleForgotPassword = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onForgotPassword();
  };

  handleMagicLink = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onMagicLink();
  };

  handleRedirect = () => {
    const { props } = this;
    const { redirectLink } = this.props;
    props.history.push(redirectLink);
  };

  render() {
    const { handleSubmit, settings, form } = this.props;
    const { redirectLink, forgotPasswordLink, magicLink } = this.props;
    const { showMessage } = this.state;
    const usesFacebook = settings.data?.facebookLogin?.usesFacebookLogin;
    const usesGoogle = settings.data?.googleLogin?.usesGoogleLogin;

    return (
      <>
        {showMessage === 'Error' && (
          <div className="c7-message--error">Error: Invalid Login</div>
        )}
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
          name="Login"
          id="c7-login-form"
        >
          <FormErrorNoRouter formName={form} />
          <Field
            name="email"
            label="Email"
            component={TextField}
            formType="email"
            autocomplete="email"
            onChange={this.handleChange}
            required
          />

          <Field
            name="password"
            label="Password"
            component={TextField}
            formType="password"
            onChange={this.handleChange}
            required
          />

          <div>
            <button type="submit" className="c7-button">
              Login
            </button>
          </div>
        </Form>

        {(usesFacebook || usesGoogle) && (
          <>
            <div>
              <span className="c7-divider-or">Or auto login using:</span>
              <br />
            </div>
          </>
        )}
        {usesFacebook && (
          <>
            <FacebookWidget
              appId={settings.data.facebookLogin.appId}
              onRedirect={this.handleRedirect}
            />
          </>
        )}
        {usesGoogle && (
          <>
            <GoogleWidget onRedirect={this.handleRedirect} />
          </>
        )}
        <p>
          <Link to={{ pathname: forgotPasswordLink, state: { redirectLink } }}>
            Forgot your password?
          </Link>
          <br />
          Or quickly login with a{' '}
          <Link to={{ pathname: magicLink, state: { redirectLink } }}>
            magic link
          </Link>
          .
        </p>
      </>
    );
  }
}

const transformData = (values) => {
  const data = {
    email: values.email,
    password: values.password
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateLogin(data);
  return errors;
};

const mapStateToProps = (state) => ({
  settings: state.setting
});

LoginWidget = reduxForm({
  form: 'login',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(LoginWidget);

export default withRouter(
  connect(mapStateToProps, {
    login
  })(LoginWidget)
);
